import React, { useState, useEffect, useRef } from 'react';
import ButtonGroup from '@visa/vds/button-group';
import ButtonText from '@visa/vds/button-text';
import Dialog from '@visa/vds/dialog';
import DialogCardBody from '@visa/vds/dialog-card-body';
import DialogCardFooter from '@visa/vds/dialog-card-footer';
import DialogCardHead from '@visa/vds/dialog-card-head';
import DialogCardHeadTitle from '@visa/vds/dialog-card-head-title';
import FormControl from '@visa/vds/form-control';
import Grid from '@visa/vds/grid';
import Row from '@visa/vds/row';
import Col from '@visa/vds/col';
import MCSSpace from '../../../components/MCSSpace';
import Checkbox from '@visa/vds/checkbox';
import CheckboxList from '@visa/vds/checkbox-list';
import CheckboxListItem from '@visa/vds/checkbox-list-item';
import Radio from '@visa/vds/radio';
import Input from '@visa/vds/input';
import { DateHelper } from '../../../_helpers/DateHelper';
import "./AnnouncementDialog.css"

import { Editor } from '@tinymce/tinymce-react';
// TinyMCE so the global var exists
// eslint-disable-next-line no-unused-vars
import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/silver';
import 'tinymce/icons/default';
import 'tinymce/skins/ui/oxide/skin.min.css';

const ViewAnnouncementDialog = (props) => {
    const detailRef = useRef(null);
    useEffect(() => {
        if (detailRef.current && props.announcement?.announcementDetails) {
            detailRef.current.innerHTML = props.announcement.announcementDetails;
        }
    }, [props.announcement]);

    return (
        <>
            <Dialog
                aria-describedby="View Announcement"
                onExit={() => { }}
                open={props.openAnnouncementDialog}
                titleId="dialog-view-announcement"
            >
                <DialogCardHead style={{height:"60px"}}>
                    <DialogCardHeadTitle id="dialog-title-manage-file">View Announcement</DialogCardHeadTitle>
                    {(props.toolsAndLibAdmin == true) &&
                        <p style={{fontSize:"13px"}}>Tools and Library Admin can view only</p>
                    }
                    {(props.storeAdmin == true) &&
                        <p style={{fontSize:"13px"}}>Store Admin can view only</p>
                    }
                </DialogCardHead>
                <DialogCardBody id="dialog-description-manage-file-field">
                    <Grid>
                        <Row noGutter key={1}>
                            <Col noTopGutter noGutter lg={12}>
                                <Input
                                    readOnly
                                    className="hide"
                                />
                                <FormControl style={{display:"inline"}}>
                                    <Input
                                        readOnly
                                        label="Announcement"
                                        name="Announcement"
                                        value={props.announcement && props.announcement.announcementName}
                                        id="Announcement"                                       
                                    />
                                </FormControl>
                            </Col>
                        </Row>
                        <MCSSpace />
                        <Row noGutter key={2}>
                            <Col noTopGutter noGutter lg={12}>
                                <FormControl>
                                    <p style={{color:"#616188"}}>Announcement Details</p>
                                    <div 
                                        ref={detailRef} 
                                        style={{ 
                                            width: "100%", 
                                            minHeight: "120px", 
                                            fontFamily: "OpenSans, sans-serif", 
                                            fontSize: "15px", 
                                            lineHeight: "1.5",
                                            border: "1px solid #d1d1d1", 
                                            borderRadius: "4px", 
                                            resize: "vertical", 
                                            backgroundColor: "#f4f4f4",
                                            overflowY: 'auto', 
                                            color: "#1b1b1f"
                                        }}
                                    />
                                </FormControl>                               
                            </Col>
                        </Row>
                        <MCSSpace />
                        {props.announcement && 
                            <Row noGutter key={3}>
                                <Col noTopGutter noGutter lg={2}>
                                    <CheckboxList>
                                        <CheckboxListItem>
                                            <Checkbox
                                                disabled
                                                checked={props.announcement.us} 
                                                id={"us"} label={"US"}
                                                name="checkbox-us"
                                            />
                                        </CheckboxListItem>
                                    </CheckboxList>
                                </Col>
                                <Col noTopGutter noGutter lg={2}>
                                    <CheckboxList>
                                        <CheckboxListItem>
                                            <Checkbox
                                                disabled
                                                checked={props.announcement.canada} 
                                                id={"canada"} label={"Canada"}
                                                name="checkbox-canada"
                                            />
                                        </CheckboxListItem>
                                    </CheckboxList>
                                </Col>
                                <Col noTopGutter noGutter lg={2}>
                                    <CheckboxList>
                                        <CheckboxListItem>
                                            &emsp;
                                            <Checkbox
                                                disabled
                                                checked={props.announcement.eu} 
                                                id={"eu"} label={"EU"}
                                                name="checkbox-eu"
                                            />
                                        </CheckboxListItem>
                                    </CheckboxList>
                                </Col>                               
                                <Col noTopGutter noGutter lg={2}>
                                    <CheckboxList>
                                        <CheckboxListItem>
                                            <Checkbox
                                                disabled
                                                checked={props.announcement.ap} 
                                                id={"ap"} label={"AP"}
                                                name="checkbox-ap"
                                            />
                                        </CheckboxListItem>
                                    </CheckboxList>
                                </Col>
                                <Col noTopGutter noGutter lg={2}>
                                    <CheckboxList>
                                        <CheckboxListItem>
                                            <Checkbox
                                                disabled
                                                checked={props.announcement.lac} 
                                                id={"lac"} label={"LAC"}
                                                name="checkbox-lac"
                                            />
                                        </CheckboxListItem>
                                    </CheckboxList>
                                </Col>
                                <Col noTopGutter noGutter lg={2}>
                                    <CheckboxList>
                                        <CheckboxListItem>
                                            <Checkbox
                                                disabled
                                                checked={props.announcement.cemea}
                                                id={"cemea"} label={"CEMEA"}
                                                name="checkbox-cemea"
                                            />
                                        </CheckboxListItem>
                                    </CheckboxList>
                                </Col>
                            </Row>
                        }
                        {props.announcement &&
                        <Row noGutter key={4} style={{display:"inline"}}>
                                <>
                                    <Radio
                                        disabled
                                        checked={props.announcement.publishState}
                                        name="publishEnable"
                                        label="Publish"
                                    />
                                    <Radio
                                        disabled
                                        checked={!props.announcement.publishState}
                                        name="publishEnable"
                                        label="Pending"
                                    />
                                </>
                            <p style={{fontSize:"11px", marginBottom:"0px"}}> Announcements that are "Pending" can only be viewed by VSS Admins. Only VSS Super Admins (SuAdmin) can update Announcements.</p>
                        </Row>
                        }
                        {props.announcement && props.announcement.publishState &&
                            <Row noGutter key={5}>
                                <Col noTopGutter noGutter lg={6}>
                                    <Input
                                        readOnly
                                        label="Publish Date"
                                        name="StartDate"
                                        id="StartDate"
                                        defaultValue={(props.announcement && props.announcement.startDate) ? DateHelper.ToLocaleDateString(props.announcement && props.announcement.startDate) : ''}
                                    />
                                </Col>
                                <Col noTopGutter noGutter lg={6}>
                                    <Input
                                        readOnly
                                        label="End Date"
                                        name="EndDate"
                                        id="EndDate"
                                        defaultValue={(props.announcement && props.announcement.endDate) ? DateHelper.ToLocaleDateString(props.announcement && props.announcement.endDate) : ''}
                                    />
                                </Col>
                            </Row>
                        }
                    </Grid>
                </DialogCardBody>
                <DialogCardFooter>
                    <ButtonGroup direction="right">
                        <ButtonText
                            colorScheme="secondary"
                            onClick={() => {
                                props.setSelectedAnnouncement(null);
                            }}
                        > Close
                        </ButtonText>
                    </ButtonGroup>
                </DialogCardFooter>
            </Dialog>
        </>
    )
}

export default ViewAnnouncementDialog